import { render, staticRenderFns } from "./ResearchEditor.vue?vue&type=template&id=64a15988"
import script from "./ResearchEditor.vue?vue&type=script&lang=js"
export * from "./ResearchEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports